import { useTranslation } from 'react-i18next'
import { Stack } from '@chakra-ui/react'

import InlineMessage from '~components/InlineMessage'

import {
  isCreatingStateSelector,
  useAdminLogicStore,
} from '../../adminLogicStore'
import { useAdminFormLogic } from '../../hooks/useAdminFormLogic'

import { HeaderBlock } from './HeaderBlock'
import { LogicBlockFactory } from './LogicBlockFactory'
import { NewLogicBlock } from './NewLogicBlock'

export const LogicContent = (): JSX.Element | null => {
  const { i18n } = useTranslation()

  const isCreatingState = useAdminLogicStore(isCreatingStateSelector)
  const { formLogics, isLoading, hasError } = useAdminFormLogic()

  if (isLoading) return null

  return (
    <Stack color="secondary.500" spacing="1rem">
      {hasError ? (
        <InlineMessage variant="error">
          {i18n.t<string>(
            'features.adminForm.create.logic.components.logicContent.thereAreErrorsInYourFormsLogicPleaseFixThemBeforeSharingYourForm',
          )}
        </InlineMessage>
      ) : null}
      <HeaderBlock />
      {formLogics?.map((logic) => (
        <LogicBlockFactory key={logic._id} logic={logic} />
      ))}
      {isCreatingState ? <NewLogicBlock /> : null}
    </Stack>
  )
}
